import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { Wallet } from "lucide-react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";

interface HeroProps {
  onCreateLottery?: () => void;
}

export const Hero = ({ onCreateLottery }: HeroProps) => {
  const { isConnected, address } = useAccount();

  return (
    <div className="relative min-h-[70vh] flex flex-col items-center justify-center px-4 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-magic-gradient opacity-40" />
      
      {/* Content */}
      <div className="relative z-10 text-center space-y-8 max-w-4xl">
        <Logo />
        
        <h1 className="text-5xl md:text-7xl font-bold text-foreground">
          Encrypted Number
          <br />
          <span className="text-primary">Lottery System</span>
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
          Participate in fair lotteries where your numbers remain encrypted until the draw.
          Privacy meets transparency on the blockchain.
        </p>
        
        <div className="flex flex-col items-center gap-4">
          <ConnectButton />
          
          {isConnected && address && (
            <div className="flex flex-col items-center gap-3">
              <div className="px-6 py-3 rounded-full bg-primary/10 border border-primary/30">
                <span className="text-sm font-medium text-primary">
                  Connected: {address.slice(0, 6)}...{address.slice(-4)}
                </span>
              </div>
              {onCreateLottery && (
                <Button
                  size="lg"
                  onClick={onCreateLottery}
                  className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all"
                >
                  Create New Lottery
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
